<template>
    <div class="mainPage">
        <ztHeader>
            <div slot="logincon" class="loginWrapper">
                <div v-if="!isLogin">
                    <span @click="toLogin()">{{ $t('message.login') }}</span> | 
                    <span @click="toLogin()">{{ $t('message.register') }}</span>
                </div>
                <div v-if="isLogin">
                    <span><span>{{user.username}}</span><span @click="toLogOut()">{{ $t('message.logout') }}</span> </span>
                </div>
            </div>
        </ztHeader>
        <div class="mainContent">
            <div class="guideCon">
                <div class="left">
                    <div class="header">
                        使用指南
                    </div>
                    <div class="list">
                        <div v-for="item in topicList" :key="item.id" class="item" :class="{'active':activeTopic.id == item.id}" @click="changeTopic(item)">
                        {{ item.name }}
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="title" v-if="!activeQuestion">
                        {{ activeTopic.name }}
                    </div>
                    <div class="title" v-if="activeQuestion&&questionInfo">
                        {{ questionInfo.question }}
                    </div>
                    <div class="content" v-if="!activeQuestion">
                        <div v-for="item in questionList" :key="item.id" class="item" @click="toArticle(item.id)">
                            {{ item.question }}
                        </div>
                    </div>
                    <div class="content questionContent" v-if="activeQuestion&&questionInfo">
                        <div v-html="questionInfo.content">
                        </div>
                    </div>
                    <div class="toolCon">
                        <div class="title">
                            自助工具
                        </div>
                        <div class="verify">
                            <a href="https://mooc-stage.chinesecio.com/verify/" target="_blank">检测设备</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <pcfooter></pcfooter>
    </div>
</template>

<script>
import ztHeader from './ztHeader'
import pcfooter from './footer'
export default {
    name: 'guide',
    components: {
        ztHeader,
        pcfooter
    },
    data: function () {
        return {
            isLogin: false,
            user: {
                username: '',
                email: ''
            },
            topicList: [], // 栏目列表
            questionList: [], // 问题列表
            questionInfo: '', // 问题详情
            activeTopic: {
                id: 1,
                name: '热门问题'
            },
            activeQuestion: undefined
        }
    },
    methods: {
        tolive (url) {
            window.open(url)
        },
        toHref (href) {
            window.open(href)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 问题详情
        toArticle(item) {
            this.activeQuestion = item
            this.$utils.get('/help/question/read', {
                question_id: this.activeQuestion
            }).then(res => {
                if(res.data.success) {
                    this.questionInfo = res.data.data
                }
            })
        },
        // 问题列表
        getQuestionList(id) {
            this.$utils.get('/help/question/getlist', {
                topic_id: id,
                limit: 999
            }).then(res => {
                if(res.data.success) {
                    this.questionList = res.data.data.list
                }
            })
        },
        // 栏目列表
        getTopicList() {
            this.$utils.get('/help/topic/getlist', {
                limit: 100
            }).then(res => {
                if(res.data.success) {
                    this.topicList = res.data.data.list
                    this.getQuestionList(this.topicList[0].id)
                    this.activeTopic = this.topicList[0]
                }
            })
        },
        changeTopic(item) {
            this.activeTopic = item
            this.activeQuestion = undefined
            this.questionInfo = undefined
            this.getQuestionList(item.id)
        }
        
    },
    mounted() {
        this.customCheckLogin()
        this.getTopicList()
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mainPage {
    text-align: center;
    position: relative;
    .loginWrapper {
        font-size: 16px;
        color: #fff;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }
    .topBg {
        width: 100%;
    }
    .mainContent {
        min-height: 1000px;
        background-color: #f0f0f0;
        text-align: center;
        .guideCon {
            width: 1200px;
            margin: auto;
            .left,.right {
                display: inline-block;
                margin-top: 20px;
            }
            .left {
                width: 250px;
                margin-right: 20px;
                background-color: #fff;
                text-align: left;
                padding-bottom: 40px;
                .header {
                    font-size: 30px;
                    color: #282828;
                    font-weight: bold;
                    padding: 31px 0 31px 25px;
                }
                .list {
                    .item {
                        width: 100%;
                        height: 50px;
                        line-height: 50px;
                        padding-left: 25px;
                        box-sizing: border-box;
                        cursor: pointer;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .active {
                        background-color: #1da1cd;
                        color: #fff;
                    }
                }
            }
            .right {
                width: 930px;
                background-color: #fff;
                vertical-align: top;
                text-align: left;
                .title {
                    font-size: 24px;
                    color: #282828;
                    padding: 35px 0 35px 65px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #f0f0f0;
                }
                .content {
                    padding: 60px 65px;
                    min-height: 300px;
                    .item {
                        font-size: 18px;
                        color: #282828;
                        margin-bottom: 25px;
                        cursor: pointer;
                    }
                    .item:hover {
                        font-weight: bold;
                    }
                }
                .questionContent {
                    /deep/ div {
                        strong {
                            font-weight: bold;
                        }
                        h1,h2,h3,h4,h5,h6 {
                        font-weight: bold;
                        font-size: 18px;
                        margin-bottom: 20px;
                        }
                        table tr,td {
                        border: 1px solid #ccc;
                        }
                        p {
                        text-indent: 2em;
                        line-height: 2.2;
                        margin-bottom: 30px;
                        a {
                            color: #0000ff;
                        }
                        strong {
                            font-weight: bold;
                        }
                        em {
                            font-style: italic;
                        }
                        img {
                            max-width: 765px;
                            text-indent: 0;
                            margin-bottom: 0px;
                            margin-left: -1em;
                            // margin-top: 10px;
                        }
                        video {
                            width: 750px;
                            height: auto;
                        }
                        h1,h2,h3,h4,h5,h6 {
                            font-weight: bold;
                        }
                        }
                    }

                }
                .toolCon {
                    margin-top: 63px;
                    border-top: 1px solid #f0f0f0;
                    padding-bottom: 40px;
                    .title {
                        border: none;
                    }
                    .verify {
                        width: 120px;
                        height: 40px;
                        line-height: 40px;
                        background-color: #fff;
                        border: 1px solid #1da1cd;
                        text-align: center;
                        color: #1da1cd;
                        margin-left: 65px;
                        cursor: pointer;
                        a {
                            display: inline-block;
                            width: 100%;height: 100%;
                            text-decoration: none;
                        }
                        a:visited,a:hover,a:active {
                            color: #1da1cd;
                        }
                    }
                    .verify:hover {
                        background-color: #1da1cd;
                        color: #fff;
                        a {
                            color: #fff;
                        }
                    }
                }
            }
        }
    }

}

</style>
